AFRAME.registerComponent("open-upload-form", {
  init() {
    const template = document.querySelector("#media-frame-placeholder");

    const menu = this.el.appendChild(document.importNode(template.content, true).children[0]);

    // Find the obj with the 'guide' name
    let guide = null;

    this.el.object3D.traverse(o => {
      if (o.name === "guide") {
        guide = o;
      }
    });

    setTimeout(() => {
      this.openUploadFormButton = menu.querySelector(".open-upload-form-button");
      this.openUploadFormButton.classList.add("media_frame_eid_" + guide.eid);

      const plane = new THREE.BoxGeometry(1, 1, 0.001);
      const material = new THREE.MeshBasicMaterial({
        color: 0xffffff,
        transparent: true,
        opacity: 0,
        side: THREE.DoubleSide,
        depthWrite: false,
        depthTest: false
      });

      const mesh = new THREE.Mesh(plane, material);
      mesh.position.set(0, 0, 0);
      mesh.scale.set(0.5, 0.5, 0.5);

      this.openUploadFormButton.setObject3D("mesh", mesh);
    });

    this.onClick = () => {
      // Emit to scene the open-upload-form event
      this.el.sceneEl.emit("open-upload-form");
    };
  },
  play() {
    setTimeout(() => {
      this.openUploadFormButton.object3D.addEventListener("interact", this.onClick);
    });
  },
  pause() {
    this.openUploadFormButton.object3D.removeEventListener("interact", this.onClick);
  }
});
